export class GraphAuthProvider {
    graphToken: string;
    constructor(graphToken: string){
      this.graphToken = graphToken;
    }
    getAccessToken = async () => {
      const token = this.graphToken;
      return token || '';
    };
  }